export default {"src":"/_next/static/media/download.0b2a3625.svg","height":21,"width":21};